module.exports = __webpack_public_path__ + "static/img/3.a68fb29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.jpg
// module id = ihpy
// module chunks = 0